import { CustomError } from './customError';

export class RestClientError extends CustomError {
    public details?: unknown;
    public status?: number;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(url: string, restError: any = {}, status?: number) {
        const message = `REST Client Error at ${url}${
            restError?.message ? `: ${restError?.message}` : ''
        }`;
        super(message, restError, restError.stack);
        if (status !== undefined) this.status = status;
    }
}
